var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.2439333%",
    y1: "15.3480958%",
    x2: "49.2439333%",
    y2: "749.499407%",
    id: "bot-linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006399",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-2812.33584%",
    x2: "50%",
    y2: "-2812.33584%",
    id: "bot-linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006399",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "118.385372%",
    y1: "-140.748061%",
    x2: "116.41898%",
    y2: "158.781708%",
    id: "bot-linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006399",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.3850571%",
    y1: "-140.748061%",
    x2: "-16.4186769%",
    y2: "158.781708%",
    id: "bot-linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006399",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.282223%",
    y1: "-9.96910142%",
    x2: "123.745396%",
    y2: "97.9081249%",
    id: "bot-linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006399",
    offset: "99%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.56,0 L14.4533,0 C13.717,0 13.12,0.597452 13.12,1.33445 L13.12,4.4437 C13.12,5.1807 13.717,5.77815 14.4533,5.77815 L17.56,5.77815 C18.2964,5.77815 18.8933,5.1807 18.8933,4.4437 L18.8933,1.33445 C18.8933,0.597452 18.2964,0 17.56,0 Z",
    id: "Path",
    fill: "url(#bot-linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#bot-linearGradient-2)",
    fillRule: "nonzero",
    points: "17.3333 5.77815 14.6667 5.77815 14.6667 8.44704 17.3333 8.44704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333,14.8257 C5.33333,14.8257 0,14.8257 0,20.1635 C0,25.5013 5.33333,25.5013 5.33333,25.5013 L5.33333,14.8257 Z",
    id: "Path",
    fill: "url(#bot-linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667,14.8257 C26.6667,14.8257 32,14.8257 32,20.1635 C32,25.5013 26.6667,25.5013 26.6667,25.5013 L26.6667,14.8257 Z",
    id: "Path",
    fill: "url(#bot-linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4FD8FF",
    fillRule: "nonzero",
    points: "26.6667 10.8224 5.33333 10.8224 5.33333 28.1701 26.6667 28.1701"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.76,11.2761 C20.4133,11.2761 24.0933,12.3036 25.24,13.2911 C26.3867,14.8657 26.1733,24.4737 24.9067,26.0751 C24.2533,26.849 21.0667,28.01 16.28,28.01 C11.24,28.01 7.73333,26.7556 6.94667,25.9283 C5.70667,24.367 5.65333,14.7189 6.84,13.211 C7.58667,12.4637 10.6667,11.2761 15.76,11.2761 Z M15.76,7.27273 C10.9067,7.27273 6.12,8.28691 4.01333,10.382 C1.25333,13.1309 1.34667,25.7948 4.01333,28.6372 C6.08,30.8524 11.2133,32 16.28,32 C21.3467,32 26.08,30.9058 27.9867,28.6372 C30.48,25.648 30.8667,12.9975 27.9867,10.382 C25.7467,8.34028 20.72,7.27273 15.76,7.27273 Z",
    id: "Shape",
    fill: "url(#bot-linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,17.975 C23,16.6852 21.9553,15.6397 20.6667,15.6397 C19.378,15.6397 18.3333,16.6852 18.3333,17.975 L18.3333,21.3111 C18.3333,22.6008 19.378,23.6464 20.6667,23.6464 C21.9553,23.6464 23,22.6008 23,21.3111 L23,17.975 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6667,17.975 C13.6667,16.6852 12.622,15.6397 11.3333,15.6397 C10.0447,15.6397 9,16.6852 9,17.975 L9,21.3111 C9,22.6008 10.0447,23.6464 11.3333,23.6464 C12.622,23.6464 13.6667,22.6008 13.6667,21.3111 L13.6667,17.975 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.61fbf3ce5daa0bf57b3873b199746da7.svg";
export { ForwardRef as ReactComponent };